// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-header-col {
  width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0 !important;
  min-height: 4.0625rem;
  border-top: 1px solid rgba(239, 239, 239, 0.25);
  background-color: black;
}
@media screen and (max-width: 991.99px) {
  .game-header-col {
    margin-top: 1rem;
  }
}
.game-header-col .header-balance {
  font-weight: 700;
}
.game-header-col .header-balance .wallet-border {
  font-size: 0.875rem;
}
.game-header-col .header-balance .wallet-border .balance-label {
  color: #FFDB49;
  text-transform: uppercase;
}
.game-header-col .header-logo img {
  max-width: 5.125rem;
}
.game-header-col .soundSetting {
  background-color: var(--primary-95);
  padding: 10px;
  position: absolute;
  top: -60px;
  left: auto;
  right: 0;
}
.game-header-col .soundSetting p {
  color: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/GameHeader/gameHeader.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,+CAAA;EACA,uBAAA;AACF;AACE;EARF;IASI,gBAAA;EAEF;AACF;AAAE;EACE,gBAAA;AAEJ;AAAI;EACE,mBAAA;AAEN;AAAM;EACE,cAAA;EACA,yBAAA;AAER;AAII;EACE,mBAAA;AAFN;AAME;EACE,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AAJJ;AAMI;EACE,mBAAA;AAJN","sourcesContent":[".game-header-col {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0 !important;\n  min-height: 4.0625rem;\n  border-top: 1px solid rgba(239, 239, 239, 0.25);\n  background-color: black;\n\n  @media screen and (max-width: 991.99px) {\n    margin-top: 1rem;\n  }\n\n  .header-balance {\n    font-weight: 700;\n\n    .wallet-border {\n      font-size: 0.875rem;\n\n      .balance-label {\n        color: #FFDB49;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  .header-logo {\n    img {\n      max-width: 5.125rem;\n    }\n  }\n\n  .soundSetting {\n    background-color: var(--primary-95);\n    padding: 10px;\n    position: absolute;\n    top: -60px;\n    left: auto;\n    right: 0;\n\n    p {\n      color: var(--white);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
